import { rand, randNumber, randWord, randPhrase, randRecentDate } from '@ngneat/falso';
import { optional } from '@library/common/functions';
import * as moment_ from 'moment';
const moment = moment_;

import { DimsUom, PiecesUom, WeightsUom } from '@library/common/models';

import {
   CartageDetailSubItem,
   CartageDetailItem,
} from '../cartage-detail-item';

export class MockCartageDetailSubItem extends CartageDetailSubItem {
   constructor() {
      super();

      this.pieces = randNumber({ max: 99 });
      this.piecesUom = rand( PiecesUom.slice() );

      if ( optional() ) {
         this.length = randNumber({ max: 99 });
         this.width = randNumber({ max: 99 });
         this.height = randNumber({ max: 99 });
         this.dimUom = rand([ ...DimsUom ]);
      }

      this.weight = randNumber({ max: 999 });
      this.weightUom = rand([ ...WeightsUom ]);

      if ( optional() ) { this.description = randPhrase(); }
      if ( optional() ) { this.reference = randWord(); }
   }
}

export class MockCartageDetailItem extends CartageDetailItem {
   constructor() {
      super();

      this.hawb = optional() ? randNumber({ max: 9999999999 }).toString() : null;

      this.pieces = randNumber({ max: 99 });
      this.piecesUom = rand( PiecesUom.slice() );

      this.weight = randNumber({ max: 999 });
      this.weightUom = rand([ ...WeightsUom ]);

      this.subItems = new Array( Math.floor( Math.random() * 10 ) + 1 ).fill( 0 ).map( _ => new MockCartageDetailSubItem() );

      if ( optional( 70 )) {
         this.pickupFromDate = randRecentDate({ days: 10 }).toString();
         this.pickupToDate = moment( this.pickupFromDate ).add( randNumber({ min: 1, max: 23 }), 'd' ).format( 'Y-MM-DD' );
         this.pickupFromTime = moment( randRecentDate({ days: 10 }) ).format( 'HH:mm:ss' );
         this.pickupToTime = moment( randRecentDate({ days: 10 }) ).add( randNumber({ min: 1, max: 720 }), 'm' ).format( 'HH:mm:ss' );
      }

      if ( optional( 70 )) {
         this.deliveryFromDate = randRecentDate({ days: 10 }).toString();
         this.deliveryToDate = moment( this.deliveryFromDate ).add( randNumber({ min: 1, max: 23 }), 'd' ).format( 'Y-MM-DD' );
         this.deliveryFromTime = moment( randRecentDate({ days: 10 }) ).format( 'HH:mm:ss' );
         this.deliveryToTime = moment( randRecentDate({ days: 10 }) ).add( randNumber({ min: 1, max: 720 }), 'm' ).format( 'HH:mm:ss' );
      }
   }
}
